<card class="mb-0">

    <h4>New Analysis</h4>
    <div class="container" *ngIf="!post; else forminfo">
        <form [formGroup]="analysisFormGroup" (ngSubmit)="onSubmit(analysisFormGroup.value)" novalidate>

            <div class="row">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Calculation Type</mat-label>
                        <mat-select placeholder="Calculation Type" formControlName="calcType"
                            required disableOptionCentering>
                            <mat-option *ngFor="let obj of getDropDownValues('calcType')" [value]="obj.name">
                                {{obj.desc}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Analysis Type</mat-label>
                        <mat-select placeholder="Analysis Type" formControlName="analysisType"
                                    required disableOptionCentering>
                            <mat-option *ngFor="let obj of analysisTypeOptions" [value]="obj.name">
                                {{obj.desc}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row" *ngIf="analysisFormGroup.get('analysisType')?.value">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Assay Type</mat-label>
                        <mat-select placeholder="Assay Type" formControlName="assayType"
                                    required disableOptionCentering>
                            <mat-option *ngFor="let obj of getDropDownValues('assayType')" [value]="obj.name">
                                {{obj.desc}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div
                *ngIf="analysisFormGroup.get('analysisType')?.value === 'QV' && analysisFormGroup.get('assayType')?.value === 'ADA'">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Workflow Type</mat-label>
                        <mat-select placeholder="Workflow Type" formControlName="adaWorkflowType"
                                    required disableOptionCentering>
                            <mat-option *ngFor="let obj of workflowTypeOptions" [value]="obj.name">
                                {{obj.desc}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div
                *ngIf="analysisFormGroup.get('assayType')?.value === 'NAB'">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Workflow Type</mat-label>
                        <mat-select placeholder="Workflow Type" formControlName="nabWorkflowType"
                                    required disableOptionCentering>
                            <mat-option *ngFor="let obj of getDropDownValues('nabWorkflowType')" [value]="obj.name">
                                {{obj.desc}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="analysisFormGroup.value.calcType && analysisFormGroup.value.calcType.indexOf('Cut-Point') !== -1">
                <div *ngIf="analysisFormGroup.get('assayType')?.value === 'NAB'">
                    <div class="col-md-9 my-3">
                        <mat-form-field>
                            <mat-label>Cut-Point Type</mat-label>
                            <mat-select placeholder="Cut-Point Type" formControlName="nabCPType"
                                        required disableOptionCentering>
                                <mat-option *ngFor="let obj of getDropDownValues('nabCPType')" [value]="obj.name">
                                    {{obj.desc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <!-- Sensitivity Only -->
            <div *ngIf="analysisFormGroup.get('calcType')?.value === 'Sensitivity'">
                <div
                    *ngIf="analysisFormGroup.get('assayType')?.value === 'ADA' && analysisFormGroup.get('adaWorkflowType')?.value !== 'nonClinVal'">
                    <div>
                        <div class="row ml-2">
                            <mat-form-field class="col-md-4 my-3">
                                <mat-label>Screening Cut-Point</mat-label>
                                <input matInput type="text" formControlName="screeningCutpoint" required>
                            </mat-form-field>
                            <mat-form-field class="col-md-4 my-3">
                                <mat-label>Screening Cut-Point Type</mat-label>
                                <mat-select placeholder="Cut-Point Type" formControlName="screenAddMult"
                                            required disableOptionCentering>
                                    <mat-option *ngFor="let obj of getDropDownValues('screenAddMult')" [value]="obj.name">
                                        {{obj.desc}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div class="col-md-9 my-3">
                            <mat-form-field>
                                <mat-label>Confirmatory Cut-Point</mat-label>
                                <input matInput type="text" formControlName="confirmatoryCutpoint" required>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="analysisFormGroup.get('assayType')?.value === 'NAB'">
                    <div class="col-md-9 my-3">
                        <mat-form-field>
                            <mat-label>Sensitivity Type (NAb)</mat-label>
                            <mat-select placeholder="Sensitivity Type" formControlName="nabSensType"
                                        required disableOptionCentering>
                                <mat-option *ngFor="let obj of getDropDownValues('nabSensType')" [value]="obj.name">
                                    {{obj.desc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div
                        *ngIf="analysisFormGroup.value.nabSensType && analysisFormGroup.value.nabSensType.startsWith('MI')">
                        <div class="col-md-9 my-3">
                            <mat-form-field>
                                <mat-label>Matrix Interference Cut-Point</mat-label>
                                <input matInput type="text" formControlName="miCutpoint" required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div
                        *ngIf="analysisFormGroup.value.nabSensType">
                        <div class="row ml-2">
                            <mat-form-field class="col-md-4 my-3">
                                <mat-label>Assay Cut-Point</mat-label>
                                <input matInput type="text" formControlName="nmiCutpoint" required>
                            </mat-form-field>
                            <mat-form-field class="col-md-4 my-3">
                                <mat-label>Assay Cut-Point Type</mat-label>
                                <mat-select placeholder="Cut-Point Type" formControlName="assayAddMult"
                                            required disableOptionCentering>
                                    <mat-option *ngFor="let obj of getDropDownValues('assayAddMult')" [value]="obj.name">
                                        {{obj.desc}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="analysisFormGroup.get('assayType')?.value === 'NAB'">
                <div class="col-md-9 my-3">
                        <mat-form-field>
                            <mat-label>NAb Type</mat-label>
                            <mat-select placeholder="NAb Type" formControlName="nabType"
                                        required disableOptionCentering>
                                <mat-option *ngFor="let obj of getDropDownValues('nabType')" [value]="obj.name">
                                    {{obj.desc}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
            </div>

            <div class="row">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Analyte Name</mat-label>
                        <input matInput type="text" formControlName="analyteName" required>
                    </mat-form-field>
                </div>
            </div>


            <div class="row">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Project Code</mat-label>
                        <input matInput formControlName="projectCode" required
                            [ngClass]="{ 'is-invalid': analysisFormGroup.controls['projectCode'].hasErrors }">
                        <mat-error *ngIf="analysisFormGroup.controls['projectCode'].errors"
                            class="invalid-feedback error">
                            <div *ngIf="analysisFormGroup.controls['projectCode'].errors.pattern">
                                Must be <strong>Alphanumeric</strong>
                            </div>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Study Code</mat-label>
                        <input matInput formControlName="studyCode" required
                            [ngClass]="{ 'is-invalid': analysisFormGroup.controls['studyCode'].hasErrors }">
                        <mat-error *ngIf="analysisFormGroup.controls['studyCode'].errors"
                            class="invalid-feedback error">
                            <div *ngIf="analysisFormGroup.controls['studyCode'].errors.pattern">
                                Must be <strong>Alphanumeric</strong>
                            </div>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row" *ngIf="analysisFormGroup.get('analysisType')?.value">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>CV Threshold</mat-label>
                        <input matInput type="text" formControlName="cvThreshold" required
                            [ngClass]="{ 'is-invalid': analysisFormGroup.controls['cvThreshold'].hasErrors }">
                        <mat-error *ngIf="analysisFormGroup.get('cvThreshold')?.errors">
                            <div *ngIf="analysisFormGroup.get('cvThreshold')?.hasError('required')">
                                CV Threshold is <strong>required</strong>.
                            </div>
                            <div *ngIf="analysisFormGroup.get('cvThreshold')?.hasError('pattern')">
                                CV Threshold must be a <strong>positive number</strong>.
                            </div>
                            <div *ngIf="analysisFormGroup.get('cvThreshold')?.hasError('max')">
                                Must be <strong>less than or equal to 100</strong>.
                            </div>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row" *ngIf="showFPR()">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Screening False Positive Rate</mat-label>
                        <mat-select formControlName="fpr" required
                            disableOptionCentering>
                            <mat-option *ngFor="let val of fprOptions" [value]="val">
                                    {{val}}
                                </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row" *ngIf="analysisFormGroup.get('analysisType')?.value && analysisFormGroup.value.calcType.indexOf('Sensitivity') !== -1">
                <div class="col-md-9 my-3">
                    <mat-form-field>
                        <mat-label>Regression Type</mat-label>
                        <mat-select formControlName="regressionType" required
                            disableOptionCentering>
                            <mat-option *ngFor="let obj of getDropDownValues('regressionType')" [value]="obj.name">
                                    {{obj.desc}}
                                </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="my-5">
                <button class="btn btn-primary m-1" color="primary" type="submit"
                        [disabled]="!analysisFormGroup.valid || !signedInUser">
                    Submit Form
                </button>
            </div>
        </form>

        <br>
        <br><br>

    </div>

    <ng-template #forminfo>
        <div class="row">
            <div class="col-md-6">
                <strong>Calculation Type: </strong>{{ getDisplayString(analysisDetails.calcType) }}
            </div>
        </div>
        <br>

        <div class="row">
            <div class="col-md-6">
                <strong>Analysis Type: </strong>{{ getDisplayString(analysisDetails.analysisType) }}
            </div>
            <div class="col-md-6">
                <strong>Assay Type: </strong>{{ getDisplayString(analysisDetails.assayType) }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.adaWorkflowType">
                <strong>ADA Workflow: </strong>{{ getDisplayString(analysisDetails.adaWorkflowType) }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.nabWorkflowType">
                <strong>NAb Workflow: </strong>{{ getDisplayString(analysisDetails.nabWorkflowType) }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.nabCPType">
                <strong>NAb Cut-Point Type: </strong>{{ getDisplayString(analysisDetails.nabCPType) }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.adaSensType">
                <strong>ADA Sensitivity Type: </strong>{{ getDisplayString(analysisDetails.adaSensType) }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.nabSensType">
                <strong>NAb Sensitivity Type: </strong>{{ getDisplayString(analysisDetails.nabSensType) }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.nabType">
                <strong>NAb Type: </strong>{{ getDisplayString(analysisDetails.nabType) }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.screeningCutpoint">
                <strong>Screening Cut-Point: </strong>{{ analysisDetails.screeningCutpoint }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.confirmatoryCutpoint">
                <strong>Confirmatory Cut-Point: </strong>{{ analysisDetails.confirmatoryCutpoint }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.miCutpoint">
                <strong>Matrix Interference Cut-Point: </strong>{{ analysisDetails.miCutpoint }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.nmiCutpoint">
                <strong>Assay Cut-Point: </strong>{{ analysisDetails.nmiCutpoint }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.screeningCutpoint">
                <strong>Screening Cut-Point Type: </strong>{{ analysisDetails.screenAddMult }}
            </div>
            <div class="col-md-6" *ngIf="analysisDetails.nmiCutpoint">
                <strong>Assay Cut-Point Type: </strong>{{ analysisDetails.assayAddMult }}
            </div>
            <div class="col-md-6"><strong>Analyte Name: </strong>{{ analysisDetails.analyteName }}</div>
            <div class="col-md-6"><strong>Project Code: </strong>{{ analysisDetails.projectCode }}</div>
            <div class="col-md-6"><strong>Study Code: </strong>{{ analysisDetails.studyCode }}</div>
            <div class="col-md-6"><strong>CV Threshold: </strong>{{ analysisDetails.cvThreshold }}</div>
            <div class="col-md-6" *ngIf="analysisFormGroup.get('assayType')?.value === 'ADA' && analysisDetails.fpr">
                <strong>FPR: </strong>{{ analysisDetails.fpr }}
            </div>
            <div class="col-md-6" *ngIf="analysisFormGroup.value.calcType.indexOf('Sensitivity') !== -1">
                <strong>Regression Type: </strong>{{ getDisplayString(analysisDetails.regressionType) }}
            </div>
        </div>

        <app-doc-upload [analysisDetails]="analysisDetails"></app-doc-upload>
    </ng-template>
</card>